import store from '@/store';
import isObject from 'lodash/isObject';
import { i18n } from '@/plugins/vue-i18n';
import toast from '@/modules/toast/services';

function displayCmsDialogFactory() {
  return function displayCmsDialog(apiResponse) {
    if (apiResponse.cmsDialog) {
      store.dispatch('dialog/CREATE', apiResponse.cmsDialog);
      return true;
    }
    return false;
  };
}

function displayCmsMessageFactory(messagesPrefix) {
  return function displayCmsMessage(apiResponse) {
    if (!('cmsMessage' in apiResponse)
      || !apiResponse.cmsMessage
    ) {
      return false;
    }

    let message = `${messagesPrefix}.${apiResponse.cmsMessage}`;
    if (!i18n.te(message)) {
      return false;
    }

    if ('cmsMessageVariables' in apiResponse
      && isObject(apiResponse.cmsMessageVariables)
    ) {
      message = i18n.t(message, apiResponse.cmsMessageVariables);
    }

    toast.notify(message);
    return true;
  };
}

function displayDefaultMessageFactory(defaultMessage) {
  return function displayDefaultMessage() {
    if (defaultMessage) {
      toast.notify(defaultMessage);
      return true;
    }

    return false;
  };
}

export function onSuccessInterceptorFactory(messagesPrefix = 'message', defaultMessage = '') {
  const stack = [
    displayCmsDialogFactory(),
    displayCmsMessageFactory(messagesPrefix),
    displayDefaultMessageFactory(defaultMessage),
  ];

  return function onSuccessInterceptor(axiosResponse) {
    const apiResponse = axiosResponse.data || {};
    stack.findIndex(fun => fun(apiResponse));

    return axiosResponse;
  };
}

export function onErrorInterceptorFactory(messagesPrefix = 'message.error', defaultMessage = '') {
  const stack = [
    displayCmsDialogFactory(),
    displayCmsMessageFactory(messagesPrefix),
    displayDefaultMessageFactory(defaultMessage),
  ];

  return function onSuccessInterceptor(axiosError) {
    const apiResponse = axiosError.response.data || {};
    stack.findIndex(fun => fun(apiResponse));

    throw axiosError;
  };
}

export const displayMessagesOnSuccessInterceptor = onSuccessInterceptorFactory();
export const displayMessagesOnErrorInterceptor = onErrorInterceptorFactory();
